import { WasteFacilityScopeBar } from "../components/WasteFacilityScopeBar";

/**
 * The containers list's facility scope bar.
 *
 * Thin wrapper over the shared bar, which the shipment list and the packaging
 * page draw too — kept as its own name so this list's call site still reads as
 * the list's own chrome.
 */
export function ContainersFilterBar({
  facilityId,
  onChangeFacility,
}: {
  facilityId: string | null;
  /** Null clears the scope back to every facility. */
  onChangeFacility: (facilityId: string | null) => void;
}) {
  return <WasteFacilityScopeBar facilityId={facilityId} onChangeFacility={onChangeFacility} />;
}
